<template>
  <div class="about-container">
    <div class="about-container_ cen">
      <Breadcrumb>
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem :to="{ path: '/about', query: { cid: fid } }">关于金色年华</BreadcrumbItem>
        <BreadcrumbItem>{{currentClassName.classname}}</BreadcrumbItem>
      </Breadcrumb>
      <div class="inside-main">
        <div class="about-detail">
          <div class="about-detail-img" v-if="detailInfo.picurl">
            <img :src="domainNameH5 + '/' + detailInfo.picurl" width="100%" alt="">
          </div>
          <div class="about-detail-cont">
            <div class="about-detail-item">{{currentClassName.classname}}</div>
            <div class="detail-cont" v-html="detailInfo.content"></div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">关于金色年华</div>
            <div class="enname">{{fname.classname_en}}</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li" v-for="item in getsort" :key="item.id" :class="[ item.id === cid ? 'active' : '']">
              <router-link :to="{ path: '/about', query: { cid: item.id } }" class="left-nav-link">
                <div class="chname">{{item.classname}}</div>
                <div class="enname">{{item.classname_en}}</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/publicwelfare" class="left-nav-link">
                <div class="chname">{{publicwelfarename.classname}}</div>
                <div class="enname">{{publicwelfarename.classname_en}}</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/seniorclass" class="left-nav-link">
                <div class="chname">{{seniorclassname.classname}}</div>
                <div class="enname">{{seniorclassname.classname_en}}</div>
                <span></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHeaderData, getAboutBasicData, getAboutData } from '../../api/getData.js'
export default {
  name: 'aboutSingle',
  data () {
    return {
      headerInfo: {},
      fid: '',
      cid: '',
      currentClassName: '',
      fname: {},
      publicwelfarename: {},
      seniorclassname: {},
      getsort: [],
      detailInfo: []
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  watch: {
    '$route': function () {
      this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
      this.getHeaderInfo()
      this.getAboutInfo()
    }
  },
  created () {
    this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
    this.getAboutBasicInfo(this.cid)
  },
  methods: {
    async getHeaderInfo () {
      let postData = { cid: this.cid }
      let header = await getHeaderData(postData)
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'about', activeSendMenu: this.cid }).then(() => {}).catch(() => {})
    },
    async getAboutBasicInfo (cid) {
      let postData = {}
      if (cid !== '') {
        postData.cid = cid
      }
      let result = await getAboutBasicData(postData)
      this.fid = result.fid
      this.cid = result.cid
      this.fname = result.fname
      this.publicwelfarename = result.publicwelfarename
      this.seniorclassname = result.seniorclassname
      this.getsort = result.aboutus
      this.getHeaderInfo()
      this.getAboutInfo()
    },
    async getAboutInfo () {
      let postData = {}
      postData.cid = this.cid
      let result = await getAboutData(postData)
      this.currentClassName = result.cname
      this.detailInfo = result.info
    }
  }
}
</script>

<style scoped lang="less">
  .about-container_{
    padding-bottom: 60px;
  }
  .about-detail{
    width: 77.22%;
    padding: 0 66px;
    background-color: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.15);
    border-radius: 5px;
    .about-detail-cont{
      padding: 0 0 80px;
      .about-detail-item{
        border-left: 4px solid #e76321;
        margin-top: 60px;
        padding-left: 20px;
        font-size: 36px;
        line-height: 36px;
        color: #e76321;
        font-weight: bold;
      }
      .detail-cont{
        margin-top: 30px;
        padding-right: 22px;
        font-size: 24px;
        line-height: 42px;
        text-align: justify;
        color: #333333;
      }
    }
  }
  @media screen and (max-width: 1300px){
    .about-detail{
      padding: 0 30px;
      .about-detail-cont{
        .about-detail-item{
          margin-top: 30px;
        }
      }
    }
  }
  @media screen and (max-width: 1200px){
    .about-detail{
      width: 100%;
      margin-bottom: 20px;
      padding: 0 15px;
      border-radius: 3px;
      .about-detail-cont{
        padding: 0 0 40px;
        .about-detail-item{
          border-left: 2px solid #e76321;
          margin-top: 30px;
          padding-left: 10px;
          font-size: 18px;
          line-height: 18px;
        }
        .detail-cont{
          margin-top: 15px;
          padding-right: 11px;
          font-size: 12px;
          line-height: 21px;
        }
      }
    }
  }
</style>
<style lang="less">
  .detail-cont{
    img,iframe,video{
      max-width: 100%;
    }
  }
</style>
